import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import i18n_setUp from "./i18n_setUp";

i18n
    .use(initReactI18next)
    .init(i18n_setUp.getInitOption());


export default i18n;